import {
    FETCH_UPDATE_PROJECT_TEMPLATE_AUTO_TASK_REQUEST,
    FETCH_UPDATE_PROJECT_TEMPLATE_AUTO_TASK_SUCCESS,
    FETCH_UPDATE_PROJECT_TEMPLATE_AUTO_TASK_FALUIRE,
} from './updateProjectTemplateAutoTaskTypes'

const initialState = {
  loading: false,
  updateProjectTemplateAutoTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPDATE_PROJECT_TEMPLATE_AUTO_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPDATE_PROJECT_TEMPLATE_AUTO_TASK_SUCCESS : return {
      ...state,
      updateProjectTemplateAutoTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPDATE_PROJECT_TEMPLATE_AUTO_TASK_FALUIRE : return {
      ...state,
      loading: false,
      updateProjectTemplateAutoTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
